module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart3-41e04e341e3651d0eadbb6559eed6646.svg";